// Utils and Constants
import { formatTime } from "../../common-utils/time-utils/TimeUtils";
import { RouteAnalysis } from "../../constants/action-constants/mavin-tools/RouteAnalysisActionConstants";

// combineHourlyAvg
function combineHourlyAvg(firstAgeSplit = {}, secondAgeSplit = {}) {
  const result = {};

  Object.keys(firstAgeSplit).forEach((hour) => {
    const val1 = Number(firstAgeSplit[hour]) || 0;
    const val2 = Number(secondAgeSplit[hour]) || 0;

    // return round off value
    const avgValue = Math.round((val1 + val2) / 2);
    result[hour] = avgValue;
  });

  return result;
}

function constructData(data = {}) {
  const {
    hourlyOTS,
    hourlyTgOTS,
    hourlyReach,
    hourlyTgReach,
    maleTgOts,
    feMaleTgOts,
    age0To4TgOts,
    age5To17TgOts,
    age18To22TgOts,
    age23To34TgOts,
    age35To44TgOts,
    age45To60TgOts,
    age60AboveTgOts,
  } = data;

  // combined age splits
  const age0To17TgOts = combineHourlyAvg(age0To4TgOts, age5To17TgOts);
  const age18To34TgOts = combineHourlyAvg(age18To22TgOts, age23To34TgOts);
  const age45AndAboveTgOts = combineHourlyAvg(age45To60TgOts, age60AboveTgOts);

  // Showing data  from 11am to 6pm
  const hoursToInclude = Object.keys(hourlyOTS).filter(
    (hour) => hour >= 6 && hour <= 23
  );

  const impressionsData = hoursToInclude.map((hour) => ({
    otsTotal: hourlyOTS[hour],
    tgOtsTotal: hourlyTgOTS[hour],
    time: formatTime(hour),
  }));

  const reachData = hoursToInclude.map((hour) => ({
    reach: hourlyReach[hour],
    tgReach: hourlyTgReach[hour],
    time: formatTime(hour),
  }));

  const genderRatioData = hoursToInclude.map((hour) => ({
    name: formatTime(hour),
    male: maleTgOts[hour],
    female: feMaleTgOts[hour],
  }));

  const ageSplitData = hoursToInclude.map((hour) => ({
    name: formatTime(hour),
    "Below-18": age0To17TgOts[hour],
    "18-34": age18To34TgOts[hour],
    "35-44": age35To44TgOts[hour],
    "45-Above": age45AndAboveTgOts[hour],
  }));

  return {
    impressionsData,
    reachData,
    genderRatioData,
    ageSplitData,
  };
}

const initialState = {
  // By Road Segment Id
  // ---------------------------------------------------
  routeInfo: {},
  constructedRouteInfo: {},
  routeInfoError: "",
  routeInfoLoading: false,

  // Route analysis pdf report download
  // --------------------------------------------------------------------
  downloadRoutePdfReportLoading: false,
  downloadRoutePdfReportError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    // By Road Segment Id
    // --------------------------------------------------------------------
    case RouteAnalysis.GET_ROUTE_SUMMARY:
      return {
        ...state,
        routeInfoLoading: true,
      };

    case RouteAnalysis.GET_ROUTE_SUMMARY_SUCCESS: {
      const { routeInfo } = action.payload;
      const constructedRouteInfo = constructData(routeInfo);
      return {
        ...state,
        constructedRouteInfo,
        routeInfo,
        routeInfoLoading: false,
      };
    }
    case RouteAnalysis.GET_ROUTE_SUMMARY_FAILURE:
      return {
        ...state,
        routeInfoLoading: false,
        routeInfoError: action.payload,
      };

    case RouteAnalysis.CLEAR_ROUTE_SUMMARY:
      return {
        ...state,
        routeInfo: {},
        constructedRouteInfo: {},
        routeInfoError: "",
        routeInfoLoading: false,
      };

    // Route analysis pdf report download
    // --------------------------------------------------------------------
    case RouteAnalysis.DOWNLOAD_ROUTE_ANALYSIS_PDF_REPORT:
      return {
        ...state,
        downloadRoutePdfReportLoading: true,
      };

    case RouteAnalysis.DOWNLOAD_ROUTE_ANALYSIS_PDF_REPORT_SUCCESS: {
      return {
        ...state,
        downloadRoutePdfReportLoading: false,
      };
    }
    case RouteAnalysis.DOWNLOAD_ROUTE_ANALYSIS_PDF_REPORT_FAILURE:
      return {
        ...state,
        downloadRoutePdfReportLoading: false,
        downloadRoutePdfReportError: "",
      };

    default:
      return state;
  }
};
